"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../../typography");
var LegendTextSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize16,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize18,
    _a);
var StyledFieldset = styled_components_1.default.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  margin: 0;\n  padding: 0;\n"], ["\n  border: none;\n  margin: 0;\n  padding: 0;\n"])));
var Legend = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, theme = _a.theme;
    return ({
        color: theme.colors.text.primary,
        sizes: [LegendTextSize[$size]],
        forwardedAs: 'legend',
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var HintText = (0, styled_components_1.default)(Legend).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.text.secondary,
        forwardedAs: 'span',
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ChildrenWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
/**
 * A basic `fieldset` component.
 * You should use this if rendering a group of inputs (such as checkboxes or radios) concerning a single subject.
 */
var Fieldset = function (_a) {
    var children = _a.children, legend = _a.legend, hint = _a.hint, _b = _a.size, size = _b === void 0 ? 'small' : _b, props = __rest(_a, ["children", "legend", "hint", "size"]);
    return (react_1.default.createElement(StyledFieldset, __assign({}, props),
        legend ? react_1.default.createElement(Legend, { "$size": size }, legend) : null,
        hint ? react_1.default.createElement(HintText, { "$size": size }, hint) : null,
        legend || hint ? (react_1.default.createElement(ChildrenWrapper, null, children)) : (children)));
};
exports.Fieldset = Fieldset;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
